import { getFocusableElements } from '../../lib/DomUtils/utils';
import { GlobalDocumentIds } from '../../types/GlobalDocumentIds';
import { KeyEvent } from '../../types/KeyEvent';

/**
 * Focus the first focusable element in the target container.
 *
 * - focus sourceElement upon shift-tab on the firstElement
 * - focus nextElement (defaults to sourceElement) when _last_
 *   focusable element in the target container looses focus
 *
 * This fn is used to focus the first element in the navigation when it's opened
 * and the user tabs via keyboard into the navigation.
 *
 * see SIBZIEL-2513
 */
function findNextFocusableElement(el: HTMLElement): HTMLElement {
  const root = document.getElementById(GlobalDocumentIds.root);
  const focusableElements = root && getFocusableElements(root);
  if (!focusableElements) return el;
  const indexOfNext = (focusableElements.indexOf(el) + 1) % focusableElements.length;
  return focusableElements[indexOfNext];
}
export const setFocusToTarget = (targetId: string, sourceElement: HTMLElement) => {
  const targetElement = document.getElementById(targetId);
  const nextElement = findNextFocusableElement(sourceElement);
  if (targetElement) {
    const focusableElements = getFocusableElements(targetElement);
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    const onKeyDownFirst = (event: KeyboardEvent) => {
      if (event.code === KeyEvent.Tab && event.shiftKey) {
        event.preventDefault();
        sourceElement.focus();
      }
    };

    const onKeyDownLast = (event: KeyboardEvent) => {
      if (event.code === KeyEvent.Tab && !event.shiftKey) {
        event.preventDefault();
        if (nextElement) {
          nextElement.focus();
        } else {
          sourceElement.focus();
        }
      }
    };

    firstElement.addEventListener('keydown', onKeyDownFirst);
    lastElement.addEventListener('keydown', onKeyDownLast);
    firstElement.focus();
  }
};
